import { render, staticRenderFns } from "./oilList.vue?vue&type=template&id=6a0928ba&scoped=true"
import script from "./oilList.vue?vue&type=script&lang=js"
export * from "./oilList.vue?vue&type=script&lang=js"
import style0 from "./oilList.vue?vue&type=style&index=0&id=6a0928ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0928ba",
  null
  
)

export default component.exports